import { Typography } from '@mui/material';
import { usePlan } from '../../context/PlanContext';

/**
 * "N / cap employees" seat usage, shown only for FREE-tier institutions — PAID institutions have
 * no seat cap to watch, and while the plan is still resolving there's nothing trustworthy to show.
 * Tone shifts to warning at 80% of the cap so an admin sees the crunch coming before they hit it.
 */
export default function SeatMeter() {
    const { planTier, employeeCount, employeeCap, ready } = usePlan();

    if (!ready || planTier !== 'FREE') return null;

    const nearCap = employeeCap > 0 && employeeCount / employeeCap >= 0.8;

    return (
        <Typography
            data-testid="seat-meter"
            data-near-cap={nearCap}
            variant="body2"
            color={nearCap ? 'warning.main' : 'text.secondary'}
            fontWeight={nearCap ? 600 : 400}
        >
            {employeeCount} / {employeeCap} employees
        </Typography>
    );
}
